import { Layout, Typography, Row, Col, Breadcrumb } from "antd";
import { Link } from "react-router-dom";
import RequestAccessModal from "../components/RequestAccessModal";
import ComplianceProgramCard from "../components/ComplianceProgramCard";
import { useState } from "react";
import { CustomFooter } from "../components/Footer";
import HeroSection from "../components/HeroSection";

// Import JSON data
import complianceProgramsData from "../data/compliancePrograms.json";
import LogoHeader from "../components/LogoHeader";

const { Content } = Layout;
const { Title, Paragraph } = Typography;

export default function ComplianceProgramsPage() {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleModalCancel = () => {
    setIsModalVisible(false);
  };

  const performSearch = (searchValue) => {
    if (!searchValue.trim()) {
      setSearchTerm("");
      setSearchResults([]);
      return;
    }

    const searchLower = searchValue.toLowerCase();
    const filteredPrograms = complianceProgramsData.filter(
      (program) =>
        program.title.toLowerCase().includes(searchLower) ||
        program.description.toLowerCase().includes(searchLower)
    );

    setSearchTerm(searchValue);
    setSearchResults(filteredPrograms);
  };

  const onSearch = (value) => {
    performSearch(value);
  };

  const compliancePrograms = complianceProgramsData;

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <LogoHeader />

      <Content style={{ padding: "48px 0", backgroundColor: "#fff" }}>
        <div
          style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 24px" }}
        >
          <Breadcrumb
            style={{ marginBottom: "12px" }}
            items={[
              {
                title: <Link to="/">Trust Center</Link>,
              },
              {
                title: "Compliance Programs",
              },
            ]}
          />

          <HeroSection
            title="Compliance Programs"
            description="We take security, compliance, and privacy seriously. Explore our certifications, reports, and policies in one place."
            onRequestAccess={showModal}
            onSearch={onSearch}
          />

          {searchTerm ? (
            // Search Results Section
            <section style={{ marginBottom: "64px" }}>
              <div
                style={{
                  marginBottom: "8px",
                  paddingTop: "1px",
                }}
              >
                <Title level={2}>Search Results for "{searchTerm}"</Title>
                <Paragraph style={{ color: "#666", marginBottom: "24px" }}>
                  Found {searchResults.length} matching compliance program
                  {searchResults.length !== 1 ? "s" : ""}
                </Paragraph>

                <Row gutter={[24, 24]}>
                  {searchResults.map((program, index) => (
                    <Col xs={24} md={8} key={index}>
                      <ComplianceProgramCard
                        program={program}
                        fixedHeight={true}
                      />
                    </Col>
                  ))}
                </Row>
              </div>
            </section>
          ) : (
            // Default Section
            <section style={{ marginBottom: "64px" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "8px",
                }}
              >
                <Title level={2}>FedRAMP</Title>
              </div>
              <Paragraph style={{ color: "#666", marginBottom: "24px" }}>
                We take security, compliance, and privacy seriously. Explore our
                certifications, reports, and policies in one place.
              </Paragraph>

              <Row gutter={[24, 24]}>
                {compliancePrograms.map((program, index) => (
                  <Col xs={24} md={8} key={index}>
                    <ComplianceProgramCard
                      program={program}
                      fixedHeight={true}
                    />
                  </Col>
                ))}
              </Row>
            </section>
          )}
        </div>
      </Content>

      <CustomFooter />

      <RequestAccessModal
        visible={isModalVisible}
        onCancel={handleModalCancel}
      />
    </Layout>
  );
}
